var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5731 25H3.42678C2.08647 25 1 23.9123 1 22.5706V3.42948C1 2.08774 2.08647 1 3.4269 1H35.573C36.9134 1 38 2.08774 38 3.4296V22.5705C38 23.9123 36.9134 25 35.5731 25Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7.23535H1V11.0148H38V7.23535Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5731 25H3.42678C2.08647 25 1 23.9123 1 22.5706V3.42948C1 2.08774 2.08647 1 3.4269 1H35.573C36.9134 1 38 2.08774 38 3.4296V22.5705C38 23.9123 36.9134 25 35.5731 25Z",
    stroke: "#303030",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.23535H37.743",
    stroke: "#303030",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7295 11.0166H1.19922",
    stroke: "#303030",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39795 20.5586H13.5535",
    stroke: "#303030",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39795 17.6064H8.33265",
    stroke: "#303030",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.23b9e506a50624d5c847c33a1c5cb5cb.svg";
export { ForwardRef as ReactComponent };